<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{ name: 'AdminUsers' }">
              <h4 class="ms-2">
                {{ label.pages.personnels }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
              @click="$router.go(-1)"
              v-b-tooltip.hover.right
              :title="label.pages.previousPage"
              class="mouse-change pe-3"
            >
              <b-icon
                icon="arrow-left-square-fill"
                variant="ps-base"
                scale="1.2"
                class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-row class="pt-3">
            <b-col cols="12" lg="5" md="6">
              <v-select
                v-model="selectedRole"
                :options="roles"
                :clearable="false"
                :reduce="(item) => item.id"
                item-color="third"
                class="ps_select"
                @input="setRole"
              >
                <template #label>
                  <label class="p-label"> نقش‌های کاربران </label>
                </template>
              </v-select>
            </b-col>
            <b-col cols="9" lg="5" md="4">
              <p class="fs-normal lh1 text-center">
                <b-icon
                  icon="info-circle"
                  scale="1.5"
                  variant="info"
                  class="mx-1"
                ></b-icon>
                با تغییر نقش لیست دسترسی‌ها نیز بروزرسانی خواهد شد و می‌توانید
                دسترسی‌های مدنظر را انتخاب و یا حذف کنید.
              </p>
            </b-col>
            <b-col cols="3" lg="2" md="2">
              <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                class="px-10 ml-2 w-100"
                @click="submit"
              >
                <b-icon icon="check2-circle" scale="1.5" class="me-1"></b-icon>
                {{ label.buttons.saveChanges }}
              </b-button>
              <b-button
                v-else
                variant="ps-success"
                class="px-10 ml-2 w-100"
                disabled
              >
                <b-spinner small></b-spinner>
                <b-icon icon="check2-circle" scale="1.5" class="me-1"></b-icon>
                {{ label.buttons.saveChanges }}
              </b-button>
            </b-col>
          </b-row>
          <b-row class="permission-wrapper" v-if="items && items.length > 0">
            <b-col
              cols="12"
              lg="4"
              md="6"
              v-for="(permit, permitIndex) in items"
              :key="permit.id"
              class="my-1"
            >
              <b-card>
                <div class="p-1">
                  <b-row>
                    <b-col sm="12">
                      <b-row
                        v-b-toggle="'accordion-' + permit.id"
                        class="p-0 m-0"
                      >
                        <b-col class="m-0 p-0" sm="11">
                          <p class="text-ps-first fs10 fw2 mb-0 py-1">
                            {{ permit.title }}
                          </p>
                        </b-col>
                        <b-col
                          class="when-closed m-0 p-0 align-self-center text-ps-first"
                          sm="1"
                        >
                          <b-icon icon="caret-down-fill" scale="0.9"></b-icon>
                        </b-col>
                        <b-col
                          class="when-open m-0 p-0 align-self-center text-ps-first"
                          sm="1"
                        >
                          <b-icon icon="caret-up-fill" scale="0.9"></b-icon>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <b-collapse
                  :id="'accordion-' + permit.id"
                  visible
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-row>
                      <div>
                        <b-form-checkbox
                          id="permit"
                          name="permit"
                          switch
                          v-model="selectedItems"
                          :value="permit.id"
                          @change="checkParent(permit)"
                        >
                          <label for="permit" class="fs-medium pe-2 fw2">
                            {{ permitIndex + 1 }}.
                            {{ permit.title }}
                          </label>
                        </b-form-checkbox>

                        <div
                          v-for="(
                            childDetail, childDetailIndex
                          ) in permit.items"
                          :key="childDetail.id"
                          class="mx-5 my-3"
                        >
                          <b-form-checkbox
                            id="permit"
                            name="permit"
                            switch
                            v-model="selectedItems"
                            :value="childDetail.id"
                          >
                            <label
                              for="supportedCompany"
                              class="fs-medium pe-2"
                            >
                              {{ permitIndex + 1 }}. {{ childDetailIndex + 1 }}.
                              {{ childDetail.title }}
                            </label>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card-body></b-card
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/plugins/StaticLabels.js";

export default {
  name: "RolePermissions",
  components: {},
  data() {
    return {
      label,
      selectedRole: this.$route.params.id,
      selectedItems: [],
    };
  },
  computed: {
    ...mapGetters({
      items: "baseX/rolePermissions",
      roles: "baseX/roleOptions",
      loadingBtn: "loadingBtn",
    }),
  },
  watch: {
    items() {
      if (this.items && this.items.length > 1) {
        this.selectedItems = [];
        this.items.forEach((item) => {
          if (item.selected === true) {
            this.selectedItems.push(item.id);
          }
          if (item.items && item.items.length > 0) {
            item.items.forEach((childDetail) => {
              if (childDetail.selected === true) {
                this.selectedItems.push(childDetail.id);
              }
            });
          }
        });
      }
    },
  },
  methods: {
    setRole() {
      this.$router.push({
        name: "RolePermissions",
        params: { id: this.selectedRole },
      });
    },
    checkParent(parent) {
      parent.items.forEach((item) => {
        var checked = this.selectedItems.indexOf(parent.id);
        if (checked > -1) {
          this.selectedItems.push(item.id);
        } else {
          var index = this.selectedItems.indexOf(item.id);
          if (index !== -1) {
            this.selectedItems.splice(index, 1);
          }
        }
      });
    },
    submit() {
      const payload = {
        roleId: this.selectedRole,
        permissionIdList: this.selectedItems,
      };
      this.$store.dispatch("baseX/updateRolePermissions", payload);
    },
  },
  mounted() {
    this.$store.dispatch("baseX/getRoles");
    if (
      this.$route.params.id
    ) {
      this.$store.dispatch("baseX/getRolePermissions", this.$route.params.id);
      this.selectedRole = Number(this.$route.params.id);
    }
  },
};
</script>
<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
